export default __webpack_public_path__ + "static/media/newlogo@2x.2e5f438b.png";